// extracted by mini-css-extract-plugin
export var footer = "_ot-0";
export var inherit = "_ot-1";
export var input = "_ot-2";
export var modalContent = "_ot-3";
export var quillEditor = "_ot-4";
export var subtitle = "_ot-5";